// Registry so the PDF export can reach live chart (G2Plot) instances that live
// deep in the component tree. A chart registers its instance when it's ready;
// right before snapshotting, the export re-renders the chart to its wrapper's
// max-width so the baked SVG can't be wider than the capped container (and so it
// fits the print page). It's restored to its on-screen size afterwards.
const charts = new Map();

export const registerChart = (id, instance) => { charts.set(id, instance); };
export const unregisterChart = (id) => { charts.delete(id); };

// Re-render `id`'s chart so its SVG matches the wrapper's CSS max-width (the
// single source of truth for the chart's print width), returning a function that
// restores its on-screen size. No-op if the chart isn't registered, can't be
// resized, or the wrapper has no max-width.
export const fitChartToMaxWidth = (id) => {
    const chart = charts.get(id);
    const el = document.getElementById(id);
    if (!chart || !el || typeof chart.changeSize !== 'function') return () => { };

    const rect = el.getBoundingClientRect();
    const liveW = Math.round(rect.width);
    const liveH = Math.round(rect.height) || 400;


    // Cap at the wrapper's max-width; never upscale past the on-screen size.

    chart.changeSize(Math.min(1020, liveW), liveH);

    return () => {
        // Back to the live on-screen width; leaving it at the print width clips
        // the chart inside its card until the next window resize.
        try { chart.changeSize(liveW, liveH); } catch (e) { /* chart may be unmounted */ }
    };
};
